import { ViewChild, ElementRef, Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Observable, Subscription } from 'rxjs/Rx';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { AppState, selectAuthState } from '@app/store/app.states';
import { LogIn, LogOut } from '@app/store/actions/auth.actions';
import { User }         from '@app/shared/models/user';
import { UserService }  from '@app/core/services/user.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { environment } from '@env/environment';
import {MatSnackBar} from '@angular/material';
import { NGXLogger,NgxLoggerLevel } from '@app/shared';

// import { ProductService } from '../product.service';

declare var $ :any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [ './login.component.scss' ],
  providers: [NGXLogger]
})
export class LoginComponent implements OnInit {

  loginFormGroup: FormGroup;
  user: User;
  isBusy:boolean = false;

  @ViewChild('email') input: ElementRef;
  @ViewChild('loginModal') loginModal: ElementRef;
  showAlert: Boolean = false;

  private getState$: Observable<any>;
  private storeSubscription:Subscription;
  private _routerSub = Subscription.EMPTY;
  constructor(
    private route: ActivatedRoute,
    private router : Router,
    private userService: UserService,
    private location: Location,
    private fb: FormBuilder,
    private store:Store<AppState>,
    public snackBar: MatSnackBar,
    private logger: NGXLogger
    //rivate env:environment;
    // private productService:ProductService
  ) {

    // get the authentication state
    this.getState$ = this.store.select(selectAuthState);
    this.storeSubscription = this.getState$.subscribe((state) => {
        this.user = state.user;
    });

    //this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event =>  this.getData());
    this._routerSub = this.router.events
             .filter(event => event instanceof NavigationEnd)
             .subscribe((value) => {

               if(this.router.url.indexOf('logout') > -1 && this.user){
                 const payload = {user:this.user}
                 this.store.dispatch(new LogOut(payload));
               }else{
                 this.router.navigateByUrl('/login');
               }
            //  this.setFocus();
             });

    // if the user is already logged in then send them to the dashboard.

    // router.events.subscribe((val) => {
    //     //console.log(val, this.router.url);
    //     // log them out
    //     if(this.router.url === '/auth/logout' && val instanceof NavigationEnd){
    //       console.log('logout',this.router.url)
    //       const payload = {user:this.user}
    //       this.store.dispatch(new LogOut(payload));
    //     }
    //     // see also
    //     if(val instanceof NavigationEnd){
    //       this.setFocus();
    //     }
    // });

    this.loginFormGroup = new FormGroup({
    //  username : new FormControl('richa.chauhan@wellcomww.com.au',[Validators.compose([Validators.required])]),
    //  password : new FormControl('richa', [Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(30)])]),
      //username : new FormControl('kk@wellcomww.com.au',[Validators.compose([Validators.required])]),
      //password : new FormControl('kkkk', [Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(30)])]),
      username : new FormControl('',[Validators.compose([Validators.required])]),
      password : new FormControl('', [Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(30)])]),
     //username : new FormControl('test@wellcom.com.au',[Validators.compose([Validators.required])]),
     //password : new FormControl('123456', [Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(30)])]),
    });

  }

  ngOnInit(): void {
    //this.getUser();
    this.user = new User();

    // subscribe to the state
    this.storeSubscription = this.getState$.subscribe((state) => {

      if(state.errorMessage && state.errorMessage.length)
        this.snackBar.open(state.errorMessage,'',{
          duration: 5000,
        });
        this.isBusy = false;
      //this.errorMessage = state.errorMessage;
    });

    // if the user is logged in and we aren't logging out then send them to the dashboard
    if(this.userService.isLoggedIn() && this.router.url.indexOf('logout') == -1){
      this.router.navigateByUrl('/main');
    }
  }

  ngAfterViewInit(){

  }

  getUser(): void {
    // const id = +this.route.snapshot.paramMap.get('id');
    // this.userService.getUser(id)
    //   .subscribe(user => {
    //     this.user = user;
    //   });
  }

  goBack(): void {
    this.location.back();
  }

  // sets focus to the input field
  setFocus():void{
    //Observable.interval(500).take(1).subscribe(() => { this.input.nativeElement.focus() } );
  }

  login(post): void{

    let username = post.username;
    let password = post.password;

    if(username.length && password.length){

      if(environment.bypass){
      //  this.router.navigate(['/dashboard']);

      }else{
        this.isBusy = true;
        const payload = {
              email: username,
              password: password
            };
        this.store.dispatch(new LogIn(payload));
      }

    }
  }

  ngOnDestroy():void{
    // unsubscribe;
    this.storeSubscription.unsubscribe();
    this._routerSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/auth/login/login.component.ts